export const FILTROS_ORDENAMIENTO_TABLA = {
    aZ: { id: 'aZ', nombre: 'A-Z' },
    zA: { id: 'Za', nombre: 'Z-A' }
  }